import { z } from 'zod';
import {
  CLAUDE_CODE_INVOCATION_NAME_VALUES,
  type ClaudeCodeInvocationName,
} from './claude-code-invocation-names';

export const ClaudeCodeInvocationNameSchema = z.enum(
  CLAUDE_CODE_INVOCATION_NAME_VALUES,
);

const CLAUDE_CODE_INVOCATION_NAME_SET = new Set<string>(
  CLAUDE_CODE_INVOCATION_NAME_VALUES,
);

export const isClaudeCodeInvocationName = (
  value: string,
): value is ClaudeCodeInvocationName =>
  CLAUDE_CODE_INVOCATION_NAME_SET.has(value);
